
export const i18n_messages = {
    'zh-CN': require('./zh-CN'),
    'en-US': require('./en-US'),
};